import { Action, Reducer } from "redux";
import {
	CompanyManufacturerActionTypes,
	CompanyManufacturerState,
	CompanyManufacturerTypes,
} from "./companyManufacturerTypes";

export const INITIAL_STATE: CompanyManufacturerState = {
	companyManufacturer: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const companyManufacturerReducer: Reducer<CompanyManufacturerState> = (
	state: CompanyManufacturerState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as CompanyManufacturerActionTypes;

	switch (actionTypes.type) {
		case CompanyManufacturerTypes.GET_COMPANY_MANUFACTURER:
			return {
				...state,
				companyManufacturer: { ...state.companyManufacturer, isLoading: true },
			};
		case CompanyManufacturerTypes.SAVE_COMPANY_MANUFACTURER:
			return {
				...state,
				companyManufacturer: {
					...state.companyManufacturer,
					isLoading: false,
					isError: actionTypes.payload.isError,
					errorMessages: actionTypes.payload.errorMessages,
					data: actionTypes.payload.data,
				},
			};
		case CompanyManufacturerTypes.RESET_REDUCER_COMPANY_MANUFACTURER:
			return {
				...state,
				companyManufacturer: INITIAL_STATE.companyManufacturer,
			};
		default:
			return state;
	}
};

export default companyManufacturerReducer;
